import { TbCalendarClock } from 'react-icons/tb'
import { DatePicker } from 'antd'

const { RangePicker } = DatePicker

const baseClass = 'w-100 custom-date-picker'

const baseStyle = {
  height: 40,
}

const renderIcon = () => (
  <TbCalendarClock
    size={22}
    style={{ strokeWidth: 1.5 }}
    color="var(--color-on-base-content-high)"
  />
)

export function DatePickerTimeGuide({
  disabled,
  disabledDate,
  format = 'DD/MM/YYYY HH:mm',
  onChange,
  ...other
}) {
  return (
    <DatePicker
      disabled={disabled}
      className={baseClass}
      style={baseStyle}
      showTime={{ format: 'HH:mm' }}
      suffixIcon={renderIcon(disabled)}
      format={format}
      disabledDate={disabledDate}
      onChange={onChange}
      allowClear={false}
      {...other}
    />
  )
}

export function DatePickerGuide({
  placeholder,
  disabled,
  disabledDate,
  format = 'DD/MM/YYYY',
  onChange,
  value, // 👈 เพิ่มตรงนี้
  allowClear = true, // 👈 ให้ override ได้
}) {
  return (
    <DatePicker
      placeholder={placeholder}
      disabled={disabled}
      className={baseClass}
      style={baseStyle}
      suffixIcon={renderIcon(disabled)}
      format={format}
      disabledDate={disabledDate}
      onChange={onChange}
      value={value} // 👈 สำคัญมาก
      allowClear={allowClear}
    />
  )
}

export function RangePickerGuide({
  disabled,
  disabledDate,
  format = 'DD/MM/YYYY',
  onChange,
}) {
  return (
    <RangePicker
      disabled={disabled}
      className={baseClass}
      style={baseStyle}
      suffixIcon={renderIcon(disabled)}
      format={format}
      disabledDate={disabledDate}
      onChange={onChange}
      allowClear={false}
    />
  )
}
